/** Shared className for inline text links inside body copy. Two
 *  callsites today: DocumentCheckbox (legal acceptance) and the
 *  ContactForm "Prefer a call?" CTA. Centralized so the design-token
 *  string doesn't drift between them. */
export const INLINE_LINK_CLASS =
  "text-primary font-medium underline underline-offset-2";
